module.exports = __webpack_public_path__ + "static/img/107.e395950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/107.png
// module id = X066
// module chunks = 0